import * as Sentry from "@sentry/react";

const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
const APP_ENV =
  process.env.REACT_APP_ENVIRONMENT ||
  process.env.NODE_ENV ||
  "development";
const APP_RELEASE =
  process.env.REACT_APP_RELEASE || process.env.REACT_APP_GIT_SHA;

let isInitialized = false;

export function initSentry() {
  if (isInitialized || !SENTRY_DSN) {
    return false;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: APP_ENV,
    release: APP_RELEASE,
    tracesSampleRate: 0,
  });

  isInitialized = true;
  return true;
}

export function captureException(error, context = {}) {
  if (!SENTRY_DSN) {
    return;
  }
  Sentry.captureException(error, context);
}

export function isSentryEnabled() {
  return Boolean(SENTRY_DSN);
}
